import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ChangeDetectorRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Form, FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';

import { ItemModel, MenuEventArgs, DropDownButtonComponent, OpenCloseMenuEventArgs  } from '@syncfusion/ej2-angular-splitbuttons';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { Payment } from './../../../shared/models/payment.model';

import { NgForm } from '@angular/forms';
import { MyobApiInvoiceSyncToolsWidgetComponent } from '../../myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';


@Component({
  selector: 'app-update-invoice-widget',
  templateUrl: './update-invoice-widget.component.html',
  styleUrls: ['./update-invoice-widget.component.css']
})
export class UpdateInvoiceWidgetComponent implements OnInit {
 

     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full
  
     job: Object;
     @Input() job_id: Observable<any[]>; 
     @Input() subject_id: Observable<any[]>; 
     @Input() subject_number?: Observable<any[]>;
     @Input() job_number: Observable<any[]>;
     @Input() invoice_id: Observable<any[]>;
   
   // access the template form
   @ViewChild('invoiceForm') invoiceForm: NgForm;

    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
 //   @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();

     invoice_model: SubjectInvoice = new SubjectInvoice();
     invoice_item_model: any = SubjectInvoiceItem;
  brand_invoice_id: any;
  brand: any;
  invoice_brand: any;
  subject_billing_items: any;
  owner_brand: any;

  // holding array items;
  invoiceItemsList: any = [];
  invoiceItem: any = [];
  isShowEdit = false ; // hidden by default]
  isShow; // hidden by default
  invoice_total_figure: number;
  invoice_tax_figure: number;
  invoice_subtotal_figure: number;
  invoice_job_type_id: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;

  public today = Date.now();
  modalRef: BsModalRef;
  invoice_status_all: any;
  invoice_payment_status_all: any;
  invoice_communication_status_all: any;
  valueDatePickerDate: Date;
  expanded = false;
  new_invoice_id: any;
  returned_invoice_id: any;
  invoice_number: any;
  returned_invoice_item_id: any;
  new_invoice_item_id: any;
  subject: any;
  invoice_status: any;
  invoice_status_name: any;
  invoice_payment_status: any;
  invoice_payment_status_name: any;
  invoice_communication_status: any;
  invoice_communication_status_name: any;
  invoice_status_id: any;
  invoice_payment_status_id: any;
  invoice_communication_status_id: any;
  invoice_status_var: any;
  invoice_payment_status_var: any;
  invoice_communication_status_var: any;
  is_job_invoice: number;
  is_job_invoice_var: any;


// dropdown buttons

@ViewChild('dialog')
  public alertDialog: DialogComponent;
  @ViewChild('dropdownbutton')
  public dropdownbutton: DropDownButtonComponent;

  public position: any = {X: 100, Y: 100};

  public alertDlgButtons: Object[] = [{
    buttonModel: {
        isPrimary: true,
        content: 'Ok, Just Testing',
        cssClass: 'e-flat',
    },
    click: function () {
        this.hide();
    }
  }];
  job_report_client_user: Object;
  report_user_contact_name: string;
  myob_invoice_id: any;
  po_number: any;
  document_number: any;
  instructions_date: any;
  f_address: string;
  invoice_myob_id: any;
  payment: any;
  paymentModel: any;
  //  // Initialize action items.
  //  public items: ItemModel[] = [
  //   {
  //       text: 'Remove From Invoice'
  //   },
  //   {
  //       text: 'Remove Completely - Invoice and Billing Task Items'
  //   },
  //   // {
  //   //     text: 'HR Portal'
  //   // },
  //   {
  //       separator: true
  //   },
  //   // {
  //   //     text: 'Other Folder...'
  //   // },
  //   {
  //       text: 'Copy to Folder'
  //   }];
    // To open dialog on selecting `Other Folder...` item.
    public select (args: MenuEventArgs) {
       if (args.item.text === 'Other Folder...') {
        this.alertDialog.show();
      }
    }


// drop down button


  
    constructor(
      private http: HttpClient, private _demoService: DemoService,
      private route: ActivatedRoute, public toastr: HotToastService,
       vcr: ViewContainerRef, private router: Router,
       public HttpClient:HttpClient,
       private fileUploader: FileUploaderService,
       private _mysqlService: MysqlService,
       private modalService: BsModalService,
       public datepipe: DatePipe,
       public gfunc: GlobalFunctionsService,
       private cdr:ChangeDetectorRef, // allows for change detection once pushed data to an array
       public _MyobApiInvoiceSyncToolsWidgetComponent: MyobApiInvoiceSyncToolsWidgetComponent
    ) {
       // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  
// Date picker date format
   this.valueDatePickerDate = new Date(this.today);



   
     }
  
     // check for changes. to load data.
     ngOnChanges(changes) {


console.log('InvoiceID: ' + this.invoice_id);
  // this.invoice_model = new SubjectInvoice();
 // this.invoice_item_model = new SubjectInvoiceItem();
 // this.getInvoice(this.invoice_id);
  
 // this.getSubjectBillingItems(this.subject_id);


  if (changes.invoice_id) {
    this.invoice_id = changes.invoice_id.currentValue;

    this.getJobSubject(this.subject_id);
    this.getJob(this.job_id);
    this.getInvoiceStatusAll();
    this.getInvoicePaymentStatusAll();
    this.getInvoiceCommunicationStatusAll();

    this.getInvoice(this.invoice_id);
    this.getInvoiceItmes(this.invoice_id);
  //  this.doCalculations(); // may need to adjust to update pricing details??
  //  this.doCalculations_ONLOAD(); // testing was commented out 24

  }

 

if (changes.item_id) {
        // deal with asynchronous Observable result
      //  this.job_id = changes.item_id.currentValue;
        // this.getJob(this.job_id);
      }
    }
  
  
    ngOnInit() {
    //  this.doCalculations_ONLOAD();
    }
  


refreshInvoice(){
  this.getJobSubject(this.subject_id);
  this.getJob(this.job_id);
  this.getInvoiceStatusAll();
  this.getInvoicePaymentStatusAll();
  this.getInvoiceCommunicationStatusAll();

  this.getInvoice(this.invoice_id);
  this.getInvoiceItmes(this.invoice_id);
}

   // Functions
 
   getInvoice(invoice_id){
    this._demoService.getSubjectInvoice(invoice_id).subscribe(
      (data) => {
        this.invoiceItem = data;
        let res = data[0];
        this.invoice_number = res.invoice_number;
        this.is_job_invoice_var = res.is_job_invoice;
        this.invoice_model.is_job_invoice = res.is_job_invoice;

        this.invoice_myob_id = res.myob_id;


           // only loads the one result!!!!! hard CDODE....
    // this.getPaymentByInvoiceID(res.invoice_id);
    if (data) {
      this.getPaymentByInvoiceID(res.invoice_id);
      }

        // Set status based in ID - For template interactions // RULES
        // this.invoice_status_text = 'PAID';
        this.getInvoiceStatus(res.invoice_status_id);
        this.getInvoicePaymentStatus(res.invoice_payment_status_id);
        this.getInvoiceCommunicationStatus(res.invoice_communication_status_id);

        this.invoice_model = this.invoiceItem;
  //      this.doCalculations_ONLOAD();

  this.myob_invoice_id = res.myob_id;

      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    ) };


     

    getPaymentByInvoiceID(invoice_id){
      this._demoService.getPaymentByInvoiceID(invoice_id).subscribe(
        (data) => {
          this.payment = data;
          this.paymentModel = this.getPayment;
          let res = data[0];
        },
        (err) => console.error(err),
       // () => console.log('Brand Loaded.')
      );
    }


    getPayment(payment_id){
      this._demoService.getPayment(payment_id).subscribe(
        (data) => {
          this.payment = data;
          this.paymentModel = this.getPayment;
          let res = data[0];
        },
        (err) => console.error(err),
       // () => console.log('Brand Loaded.')
      );
    }


   getInvoiceItmes(invoice_id){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];


        this.invoice_item_model = this.invoiceItemsList;
       this.doCalculations();
  // this.doCalculations_ONLOAD(); // if on load runs it suffs up when adding items as it then calculates from the database total not the floadting calculated totals on the page.
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    ) };
 


    
    getJobSubject(subject_id) {
      this._demoService.getJobSubject(subject_id).subscribe(
        data => { this.subject = data;
          let res = data[0];
          this.subject_number = res.subject_number;
         // this.job_number = res.job_id + '.1'; // made up
         // console.log("Done loadng USER");

         if (!res.street_address){
          this.f_address = '';
        }else{
          this.f_address = res.street_address +  ' ' + res.suburb +  ' ' + res.state +  ',  ' + res.postcode;
        }


        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }
 
 
    getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
        // Run the job data queries.
      this.brand_invoice_id =  res.brand_invoice_id;
      this.invoice_job_type_id = res.job_type_id;
      this.getInvoiceBrand(res.brand_invoice_id);
      this.getOwnerBrand(94);

      // show the report user name on invoices 29/01/24
      this.getJobReportUser(res.brand_report_user_id)

      this.po_number = res.owner_trace_code;
      this.document_number = res.document_number;
      this.instructions_date = res.instructions_date;

// setup the invoice holding data (this did NOT load the form data without running a ngfor statement)
  // Setup the SubjectInvoice
  // this.invoiceItem.push({
  //   invoice_number: this.subject_number,
  //   job_id: this.job_id,
  //   to_brand_id: this.brand_invoice_id,
  //   subject_id: this.subject_id,
  //   job_type_id: this.invoice_job_type_id,
  //   file_id: null,
  //   created_by: this.sessionUserId,
  // //  date_created: this.today,
  //   invoice_total: this.invoice_total_figure,
  //   invoice_gst: this.invoice_tax_figure,
  //   invoice_subtotal: this.invoice_subtotal_figure,
  //   invoice_status_id: 1,
  //   invoice_payment_status_id: 1,
  //   invoice_communication_status_id: 1,
  //   from_brand_id: 94,
  // //  due_date: this.today,
  //   job_number: this.job_number,
  //         });



/*
          this.invoiceItem = [{
            invoice_number: this.subject_number,
            job_id: this.job_id,
            to_brand_id: this.brand_invoice_id,
            subject_id: this.subject_id,
            job_type_id: this.invoice_job_type_id,
            file_id: null,
            created_by: this.sessionUserId,
            date_created: this.valueDatePickerDate,
            invoice_total: this.invoice_total_figure,
            invoice_gst: this.invoice_tax_figure,
            invoice_subtotal: this.invoice_subtotal_figure,
            invoice_status_id: '1',
            invoice_payment_status_id: '1',
            invoice_communication_status_id: '1',
            from_brand_id: 94,
            due_date: this.valueDatePickerDate,
            job_number: this.job_number,
          }];

          this.invoice_model = this.invoiceItem;

*/

          // :: In order to reflect the data changes on the template, you need to use detect changes, DID NOTHING!
          // ::: constructor(private cdr:ChangeDetectorRef) 
          // and apply the following once you push the data  
          // ::: this.cdr.detectChanges();
       
       
          this.cdr.detectChanges();

        //  this.doCalculations_ONLOAD();


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   private getInvoiceBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.invoice_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }


      // show the report user name on invoices 29/01/24
  getJobReportUser(brand_report_user_id) {
    this._demoService.getUsersById(brand_report_user_id).subscribe(
       data => { 
            this.job_report_client_user = data;

            this.report_user_contact_name = this.job_report_client_user[0].first_name + ' ' + this.job_report_client_user[0].surname;

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

  
  private getOwnerBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.owner_brand = data;
        let res = data[0];
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }



  getInvoiceStatus(invoice_status_id){
    this._demoService.getInvoiceStatus(invoice_status_id).subscribe(
      (data) => {
        this.invoice_status = data;
        let res = data[0];
        this.invoice_status_name = res.invoice_status_name;
        this.invoice_status_var = invoice_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  
  getInvoicePaymentStatus(invoice_payment_status_id){
    this._demoService.getInvoicePaymentStatus(invoice_payment_status_id).subscribe(
      (data) => {
        this.invoice_payment_status = data;
        let res = data[0];
        this.invoice_payment_status_name = res.invoice_payment_status_name;
        this.invoice_payment_status_var = invoice_payment_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getInvoiceCommunicationStatus(invoice_communication_status_id){
    this._demoService.getInvoiceCommunicationStatus(invoice_communication_status_id).subscribe(
      (data) => {
        this.invoice_communication_status = data;
        let res = data[0];
        this.invoice_communication_status_name = res.invoice_communication_status_name;
        this.invoice_communication_status_var = invoice_communication_status_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }





  getInvoiceStatusAll(){
    this._demoService.getInvoiceStatusAll().subscribe(
      (data) => {
        this.invoice_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getInvoicePaymentStatusAll(){
    this._demoService.getInvoicePaymentStatusAll().subscribe(
      (data) => {
        this.invoice_payment_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getInvoiceCommunicationStatusAll(){
    this._demoService.getInvoiceCommunicationStatusAll().subscribe(
      (data) => {
        this.invoice_communication_status_all = data;
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }

  getSubjectBillingItemsSaveToInvoice(subject_id) {
    // empty array of invoiceItemsList first
   this.invoiceItemsList = [];
    this._demoService.getSubjectBillingItems(subject_id).subscribe(
      data => { this.subject_billing_items = data;

        // :: lenght object ::  filter the array for all not invoiced - as API returns all. an easier coding way.
      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

 let tax_percent;
 let tax_value = 0;
  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4  ) {
    // tax_percent = 10;
    // tax_value = (res.billing_task_fee / (100 / tax_percent));
    // tax_value = (res.billing_task_fee / 11);
    // tax_value = (res.billing_task_fee / (100 / tax_percent)); // + GST
    tax_value = (res.billing_task_fee / (100 / tax_percent)) * res.qty; // + GST * qnty // added so that when calculating GST takes qtny into consideratin. 31/01/24

    // fix for two decimaal precicion for myob
        let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
        tax_value = rounded_tax_value;
        // tax_value = (res.billing_task_fee / 11); // exclusive
      //  new_total = (+res.billing_task_fee + +tax_value); // + GST
      //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
      //  new_total = rounded_new_total;
  }
  if(res.myob_tax_code_id != 1 && res.myob_tax_code_id != 4) {
    tax_percent = 0;
    tax_value = 0;
  }

  // :: added the invvoice items needed to the array push.

        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
       this.invoiceItemsList.push({
invoice_number: res.job_number,
invoice_id: this.invoice_id,
// invoice_item_id: res.invoice_item_id, // we dont have this yet? as you are inserting...
billing_task_id: res.billing_task_id,
subject_billing_item_id: res.subject_billing_item_id,
billing_task_name: res.billing_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_fee: res.billing_task_fee,
billing_task_description: res.billing_task_description,
subject_id: res.subject_id,
subject_number: res.subject_number,
job_id: res.job_id,
job_number: res.job_number,
qty: 1,
unit_price: res.billing_task_fee,
tax: tax_value,
total: +res.billing_task_fee + +tax_value,
      });



    // TOD:::
// :: Add for Update to insert subjectBillingItems into invoiceItems.
   // :: while in s in a loop
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.addSubjectInvoiceItem(invoiceData, this.invoice_id);
   // :: Update the status of the subjectBillingItems because we added them to the invoice items database
  let invoice_status = "INVOICED";


  setTimeout( () => { 
    this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.invoice_id, this.invoice_number, invoiceData);
   }, 400 );



  this.invoiceItemsList = this.invoiceItemsList; // know Idear if I even need this in the loop???? seems I do?

// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_fee,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count


    // refresh the invoice data.
    // this.getInvoice(this.invoice_id);

    this.toastr.success('Invoice & Billing Items Added: Please open Invoice again to view changes.');
    // this.closeParentModel.emit();
    // :: Now refresh the invoice page below to reflect changes in subjectBillingItems.

    setTimeout( () => { 
      this.refreshSujectInvoicePage(this.subject_id);
     }, 2000 );

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total_figure = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);

// set a delay to load invoice items.. THIS WORKED!!!!!! 
setTimeout( () => { 
  this.getInvoiceItmes(this.invoice_id);
 }, 800 );

 this.doCalculations();
return true;

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );

// this.invoiceItemsList = [];    
// this.getInvoice(this.invoice_id);
// this.getInvoiceItmes(this.invoice_id);
 this.doCalculations();
  }


  getJobBillingItemsSaveToInvoice(job_id) {
    // empty array of invoiceItemsList first
   this.invoiceItemsList = [];
    this._demoService.getJobBillingItems(job_id).subscribe(
      // leave as same data as not to change too much code.
      data => { this.subject_billing_items = data;

        // :: lenght object ::  filter the array for all not invoiced - as API returns all. an easier coding way.
      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

 let tax_percent;
 let tax_value = 0;
//  res.total =  res.billing_task_fee; // set as default;
  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4) {
    tax_percent = 10;
    // tax_value = (res.billing_task_fee / (100 / tax_percent));
    // tax_value = (res.billing_task_fee / 11);
    // tax_value = (res.billing_task_fee / (100 / tax_percent)); // + GST
    tax_value = (res.billing_task_fee / (100 / tax_percent)) * res.qty; // + GST * qnty // added so that when calculating GST takes qtny into consideratin. 31/01/24

        // fix for two decimaal precicion for myob
        let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
        tax_value = rounded_tax_value;
        // tax_value = (res.billing_task_fee / 11); // exclusive
      //  new_total = (+res.billing_task_fee + +tax_value); // + GST
      //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
      //  new_total = rounded_new_total;
  }
  if(res.myob_tax_code_id != 1 && res.myob_tax_code_id != 4 ) {
    tax_percent = 0;
    tax_value = 0;
  }
  

  // :: added the invvoice items needed to the array push.

        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
       this.invoiceItemsList.push({
invoice_number: res.job_number,
invoice_id: this.invoice_id,
invoice_item_id: res.invoice_item_id, // we dont have this yet? as you are inserting...
billing_task_id: res.billing_task_id,
subject_billing_item_id: res.subject_billing_item_id,
billing_task_name: res.billing_task_name,
myob_tax_code_id: res.myob_tax_code_id,
myob_account_code_id: res.myob_account_code_id,
billing_task_fee: res.billing_task_fee,
billing_task_description: res.billing_task_description,
subject_id: res.subject_id,
subject_number: res.subject_number,
job_id: res.job_id,
job_number: res.job_number,
// qty: 1,
qty: res.qty,
unit_price: res.billing_task_fee,
tax: tax_value,
// total: ((res.billing_task_fee + tax_value) * res.qty),
total: res.total,

      });



    // TOD:::
// :: Add for Update to insert subjectBillingItems into invoiceItems.
   // :: while in s in a loop
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.addSubjectInvoiceItem(invoiceData, this.invoice_id);
   // :: Update the status of the subjectBillingItems because we added them to the invoice items database
  let invoice_status = "INVOICED";


  setTimeout( () => { 
    this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.invoice_id, this.invoice_number, invoiceData);
   }, 400 );



  this.invoiceItemsList = this.invoiceItemsList; // know Idear if I even need this in the loop???? seems I do?

// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_fee,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count


    // refresh the invoice data.
    // this.getInvoice(this.invoice_id);

    this.toastr.success('Invoice & Billing Items Added: Please open Invoice again to view changes.');
    // this.closeParentModel.emit();
    // :: Now refresh the invoice page below to reflect changes in subjectBillingItems.

    setTimeout( () => { 
      this.refreshSujectInvoicePage(this.subject_id);
     }, 2000 );

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total_figure = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);

// set a delay to load invoice items.. THIS WORKED!!!!!! 
setTimeout( () => { 
  this.getInvoiceItmes(this.invoice_id);
 
 }, 800 );

//  this.doCalculations(); //original feb 2023
return true;

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );

// this.invoiceItemsList = [];    
// this.getInvoice(this.invoice_id);
// this.getInvoiceItmes(this.invoice_id);
//  this.doCalculations_ONLOAD();
  }







  // uses this one on create invoice add item...
  getSubjectBillingItems(subject_id) {
    // empty array of invoiceItemsList first
    this.invoiceItemsList = [];
    this._demoService.getSubjectBillingItems(subject_id).subscribe(
      data => { this.subject_billing_items = data;

      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];


            // Dont need
        // do some totals and tax calculations.

                 let tax_percent;
                 let tax_value = 0;
                //  let new_total = 0; // + GST
                let new_total = 0; // + GST
                  if(res.myob_tax_code_id == 1 || res.myob_tax_code_id == 4  ) {
                    tax_percent = 10;
                    // tax_value = (res.billing_task_fee / (100 / tax_percent));
                    // tax_value = (res.billing_task_fee / 11); // exclusive
                    tax_value = (res.billing_task_fee / (100 / tax_percent)); // + GST
                    // fix for two decimaal precicion for myob
                    let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
                    tax_value = rounded_tax_value;
                    // tax_value = (res.billing_task_fee / 11); // exclusive
                   new_total = (+res.billing_task_fee + +tax_value); // + GST
                       let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
                       new_total = rounded_new_total;
                  }
                  if(res.myob_tax_code_id != 1 && res.myob_tax_code_id != 4 ) { /// anything else other than GST is all we neee no tax or free  // + GST
                    tax_percent = 0;
                    tax_value = 0;
                    new_total = res.billing_task_fee; // + GST
                
                  }
 
/*
   let rounded_data_tax = Math.round((this.row_data.tax + Number.EPSILON) * 100) / 100;
   this.row_data.tax = rounded_data_tax;
*/


// --- CHANGED THIS ONE ANYWAY BEAUSE ITS USED ELSEHWERE...

    // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
    // this.invoiceItemsList.push({
    //   invoice_number: res.job_number,
    //   billing_task_id: res.billing_task_id,
    //   subject_billing_item_id: res.subject_billing_item_id,
    //   billing_task_name: res.billing_task_name,
    //   myob_tax_code_id: res.myob_tax_code_id,
    //   myob_account_code_id: res.myob_account_code_id,
    //   billing_task_fee: res.billing_task_fee,
    //   billing_task_description: res.billing_task_description,
    //   subject_id: res.subject_id,
    //   subject_number: res.subject_number,
    //   job_id: res.job_id,
    //   job_number: res.job_number,
    //   qty: 1,
    //   unit_price: res.billing_task_fee,
    //   tax: tax_value,
    //   total: +res.billing_task_fee + +tax_value
    //   // tslint:disable-next-line:max-line-length
    //   // total: new_total, // + GST // was not adding correctly do do not use..?????? (fix you need to add +variable to the start of the variable to add in typescrupt!)
    //   // total: (+res.billing_task_fee + +tax_value), // + GST
    //   // total: res.billing_task_fee,
    //         });
  
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                   this.invoiceItemsList.push({
            invoice_number: res.invoice_number,
            billing_task_id: res.billing_task_id,
            subject_billing_item_id: res.subject_billing_item_id,
            billing_task_name: res.billing_task_name,
            myob_tax_code_id: res.myob_tax_code_id,
            myob_account_code_id: res.myob_account_code_id,
            billing_task_fee: res.billing_task_fee,
            billing_task_description: res.billing_task_description,
            subject_id: res.subject_id,
            subject_number: res.subject_number,
            job_id: res.job_id,
            job_number: res.job_number,
            qty: res.qty,
            unit_price: res.billing_task_fee,
            tax: res.tax,
            total: res.total
            // tslint:disable-next-line:max-line-length
            // total: new_total, // + GST // was not adding correctly do do not use..?????? (fix you need to add +variable to the start of the variable to add in typescrupt!)
            // total: (+res.billing_task_fee + +tax_value), // + GST
            // total: res.billing_task_fee,
                  });


      this.invoiceItemsList = this.invoiceItemsList;










// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_fee,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total_figure = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
this.doCalculations();

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }





  /// changed below and copied from the create invocie compoonent.

  getSubjectBillingItems_original_MARCH2023(subject_id) {
    // empty array of invoiceItemsList first
    this.invoiceItemsList = [];
    this._demoService.getSubjectBillingItems(subject_id).subscribe(
      data => { this.subject_billing_items = data;

      let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED'));

      let  count_of_items = Object.keys(newArr).length;
     //  let res = data[0];
       // Run the job data queries.

       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
        let res = newArr[i];
  // do some totals and tax calculations.

                  //  let tax_percent;
                  //  let tax_value = 0;
                  //   if(res.myob_tax_code_id == 1) {
                  //     tax_percent = 10;
                  //     tax_value = (res.billing_task_fee / (100 / tax_percent));
                  //     // tax_value = (res.billing_task_fee / 11);
                  //         // fix for two decimaal precicion for myob
                  //         let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
                  //         tax_value = rounded_tax_value;
                  //         // tax_value = (res.billing_task_fee / 11); // exclusive
                  //       //  new_total = (+res.billing_task_fee + +tax_value); // + GST
                  //       //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
                  //       //  new_total = rounded_new_total;
                  //   }
                  //   if(res.myob_tax_code_id == 2) {
                  //     tax_percent = 0;
                  //     tax_value = 0;
                  //   }
                  
                  //   // @ :: Added invoice id to the list on update items.
                  //         // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                  //        this.invoiceItemsList.push({
                  // invoice_number: res.job_number,
                  // invoice_id: this.invoice_id,
                  // billing_task_id: res.billing_task_id,
                  // subject_billing_item_id: res.subject_billing_item_id,
                  // billing_task_name: res.billing_task_name,
                  // myob_tax_code_id: res.myob_tax_code_id,
                  // myob_account_code_id: res.myob_account_code_id,
                  // billing_task_fee: res.billing_task_fee,
                  // billing_task_description: res.billing_task_description,
                  // subject_id: res.subject_id,
                  // subject_number: res.subject_number,
                  // job_id: res.job_id,
                  // job_number: res.job_number,
                  // qty: 1,
                  // unit_price: res.billing_task_fee,
                  // tax: tax_value,
                  // total: res.billing_task_fee += tax_value,
                  // // total: res.total,
                  //       });



// 2023 update so that that when updateing status of the invoice the invoice calculations stay correct - was disrupting the fugures....
                  let tax_percent;
                  let tax_value = 0;
                   if(res.myob_tax_code_id == 1) {
                     tax_percent = 10;
                     tax_value = (res.billing_task_fee / (100 / tax_percent));
                         // fix for two decimaal precicion for myob
                         let rounded_tax_value = Math.round((tax_value + Number.EPSILON) * 100) / 100;
                         tax_value = rounded_tax_value;
                         // tax_value = (res.billing_task_fee / 11); // exclusive
                       //  new_total = (+res.billing_task_fee + +tax_value); // + GST
                       //  let rounded_new_total = Math.round((new_total + Number.EPSILON) * 100) / 100;
                       //  new_total = rounded_new_total;
                   }
                   if(res.myob_tax_code_id == 2) {
                     tax_percent = 0;
                     tax_value = 0;
                   }
                  
                   
                         // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                        this.invoiceItemsList.push({
                 invoice_number: res.job_number,
                 billing_task_id: res.billing_task_id,
                 subject_billing_item_id: res.subject_billing_item_id,
                 billing_task_name: res.billing_task_name,
                 myob_tax_code_id: res.myob_tax_code_id,
                 myob_account_code_id: res.myob_account_code_id,
                 billing_task_fee: res.billing_task_fee,
                 billing_task_description: res.billing_task_description,
                 subject_id: res.subject_id,
                 subject_number: res.subject_number,
                 job_id: res.job_id,
                 job_number: res.job_number,
                 qty: 1,
                 unit_price: res.billing_task_fee,
                 tax: tax_value,
                 total: res.billing_task_fee,
                       });






      this.invoiceItemsList = this.invoiceItemsList;

// this.invoiceItemsList = [{
//   invoice_number: res.job_number,
//   billing_task_id: res.billing_task_id,
//   subject_billing_item_id: res.subject_billing_item_id,
//   billing_task_name: res.billing_task_name,
//   myob_tax_code_id: res.myob_tax_code_id,
//   myob_account_code_id: res.myob_account_code_id,
//   billing_task_fee: res.billing_task_fee,
//   billing_task_description: res.billing_task_description,
//   subject_id: res.subject_id,
//   subject_number: res.subject_number,
//   job_id: res.job_id,
//   job_number: res.job_number,
//   qty: 1,
//   unit_price: res.billing_task_description,
//   tax: tax_value,
//   total: res.billing_task_fee,
//         }];

    } // end for loop count

  // do some global calculations
// get sum of msgCount prop across all objects in array
// gets fee * qty adds them all up
// this.invoice_total_figure = this.invoiceItemsList.reduce((acc, val) => acc += (val.billing_task_fee * val.qty ), 0);
this.doCalculations_ONLOAD();

     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
 


  createSubjectInvoice(invoice_model) {

// invoice_model = [invoice_model]; // see if I can trick to make an object from form values missing brackets [{}]
// // :: need to add the [0] for #formname.value inserts.
// console.log(invoice_model);
//     this._demoService.createSubjectInvoice(invoice_model[0]).subscribe(
//        data => {  this.new_invoice_id = data;
//         let res = data[0];
//         // Run the insert of insert objects through a loop.
//         // let invoice_id = res.last_insert_id;

//         // console.log('InvoiceID: ' + invoice_id);

//         this.toastr.success('Invoice Entered');
//         this.closeParentModel.emit();
//       },
//        err => console.error(err),
//        // () => console.log('done loading Trace Types')
//      );



     this._demoService.createSubjectInvoice(invoice_model).subscribe(
      data => {  this.new_invoice_id = data; // this is the retuned json upon creation.

        let res = data[0];
                // Run the insert of insert objects through a loop.
                this.returned_invoice_id = this.new_invoice_id.last_insert_id;
                console.log(this.returned_invoice_id);

// now inset the items
let  count_of_items = Object.keys(this.invoiceItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.addSubjectInvoiceItem(invoiceData, this.returned_invoice_id);
// :: now update subjectBillingItems Status using the model subjectbillingitemid.
let invoice_status = "INVOICED";
this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.returned_invoice_id, this.subject_number, invoiceData);
  } // end for

        this.toastr.success('Invoice Entered');
        this.closeParentModel.emit();
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
        this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
};



   addSubjectInvoiceItem(model, invoice_id){
    this._demoService.addSubjectInvoiceItem(model, invoice_id).subscribe(
      data => {  this.new_invoice_item_id = data; // this is the retuned json upon creation.
        // let res = data[0];
                        // Run the insert of insert objects through a loop.
                        this.returned_invoice_item_id = this.new_invoice_item_id.last_insert_id;
                        console.log(this.returned_invoice_id);
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   }

// :: FIX :: CURRENT SPOTTHis needs to be totally re-written and followed through from start to check what I am actually doing here
// :: !!! GOING WRONG API NEEDS TO UPDATE BY invoice_item_id // Not by billing_item_id???
   updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model){
    this._demoService.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model).subscribe(
      data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
        // let res = data[0];
      // this.router.navigate(['../../companies'], { relativeTo: this.route });
       return true;
      },
      error => {
        console.error(error);
     //  this.toastr.error('Adding Failed :: Please try again!');
       // console.log(Observable.throw(error));
        // return Observable.throw(error);
      }
 )
   }



//  New Function Working August 2022 = + GST
doCalculations() {

  // this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates !!!!!! NUMBER FORMAT MISSING>>>>>
this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax), 0); // now calculates
  this.invoice_model.invoice_gst = this.invoice_tax_figure;

  // this.toastr.info('Calculating...');
  // this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
  this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.total), 0);
  this.invoice_model.invoice_total = this.invoice_total_figure;

  this.invoice_subtotal_figure = (this.invoice_total_figure - this.invoice_tax_figure); // 
  this.invoice_model.invoice_subtotal = this.invoice_subtotal_figure;

  this.invoice_model = this.invoiceItem;

  // updated by
  let update_user = this.sessionUserId;
  this.invoice_model.updated_by = this.sessionUserId;  

      this.invoiceForm.controls['updated_by'].setValue(update_user);
      this.invoiceForm.controls['invoice_total'].setValue(this.invoice_total_figure);
      this.invoiceForm.controls['invoice_subtotal'].setValue(this.invoice_subtotal_figure);
      this.invoiceForm.controls['invoice_gst'].setValue(this.invoice_tax_figure);


      console.log('Calcuated Fugures: Normal ');

 // 

}


doCalculations_March(){

//  this.invoice_model = this.invoiceItem;

  // this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates !!!!!! NUMBER FORMAT MISSING>>>>>
  this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax), 0); // now calculates
  this.invoice_model.invoice_gst = this.invoice_tax_figure;

  // this.toastr.info('Calculating...');
  this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.total + b.tax), 0);
  // this.invoice_model.invoice_total = this.invoice_total_figure;
  this.invoice_model.invoice_total = this.invoice_total_figure + this.invoice_tax_figure;

  
  // this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
  // this.invoice_model.invoice_total = this.invoice_total_figure += this.invoice_tax_figure;

  // this.invoice_subtotal_figure = (this.invoice_total_figure - this.invoice_tax_figure); // take the tax because I added it above.? or dont take the tax????
  // this.invoice_subtotal_figure = (this.invoice_total_figure -= this.invoice_tax_figure); // take the tax because I added it above.? or dont take the tax????
  this.invoice_subtotal_figure = (this.invoice_total_figure); // dont take the tax!
  this.invoice_model.invoice_subtotal = this.invoice_subtotal_figure;

  // updated by
  let update_user = this.sessionUserId;
  this.invoice_model.updated_by = this.sessionUserId;  

      this.invoiceForm.controls['updated_by'].setValue(update_user);
      this.invoiceForm.controls['invoice_total'].setValue(this.invoice_total_figure);
      this.invoiceForm.controls['invoice_subtotal'].setValue(this.invoice_subtotal_figure);
      this.invoiceForm.controls['invoice_gst'].setValue(this.invoice_tax_figure);


      console.log('Calcuated Fugures: Normal ');

  }


  doCalculations_ONLOAD(){

    //  this.invoice_model = this.invoiceItem;
    
      // this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates !!!!!! NUMBER FORMAT MISSING>>>>>
                      this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax), 0); // now calculates
                      this.invoice_model.invoice_gst = this.invoice_tax_figure;
                    
                      // this.toastr.info('Calculating...');
                      // this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
                      this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.total), 0);
                      this.invoice_model.invoice_total = this.invoice_total_figure + this.invoice_tax_figure;
                      
                      // this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
                      // this.invoice_model.invoice_total = this.invoice_total_figure += this.invoice_tax_figure;
                    
                      this.invoice_subtotal_figure = (this.invoice_total_figure - this.invoice_tax_figure); // 
                      this.invoice_model.invoice_subtotal = this.invoice_subtotal_figure;
                    
                      this.invoice_model = this.invoiceItem;
                      // updated by
                      let update_user = this.sessionUserId;
                      this.invoice_model.updated_by = this.sessionUserId;  

                    console.log('Calcuated Fugures: On Load');
    
      }

  // doCalculations_ONLOAD(){

  //   //  this.invoice_model = this.invoiceItem;
    
  //     // this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates !!!!!! NUMBER FORMAT MISSING>>>>>
  //     this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax), 0); // now calculates
  //     this.invoice_model.invoice_gst = this.invoice_tax_figure;
    
  //     // this.toastr.info('Calculating...');
  //     this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.total + b.tax), 0);
  //     this.invoice_model.invoice_total = this.invoice_total_figure;
      
  //     // this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
  //     // this.invoice_model.invoice_total = this.invoice_total_figure += this.invoice_tax_figure;
    
  //     this.invoice_subtotal_figure = (this.invoice_total_figure - this.invoice_tax_figure); // take the tax because I added it above.? or dont take the tax????
  //     // this.invoice_subtotal_figure = (this.invoice_total_figure -= this.invoice_tax_figure); // take the tax because I added it above.? or dont take the tax????
  //     this.invoice_model.invoice_subtotal = this.invoice_subtotal_figure;
    
  //     // updated by
  //     let update_user = this.sessionUserId;
  //     this.invoice_model.updated_by = this.sessionUserId;  

  //   console.log('Calcuated Fugures: On Load');
    
  //     }



// can also run from a child component. // New GEST working 2022
doCalculations______() {


  // this.invoice_tax_figure = (this.invoice_model.invoice_total / (100 / 10));
// this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates
this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax ), 0); // now calculates
this.invoice_model.invoice_gst = this.invoice_tax_figure;




  // this.toastr.info('Calculating...');
  this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.total + b.tax), 0); // gets all the row totals.
  this.invoice_model.invoice_total = this.invoice_total_figure += this.invoice_tax_figure; // do I need to add tax? - Yes added  change!!!! August 2020
 
  // :: Test Stop errors of input
 // this is needed but does throw errows 
  this.invoiceForm.controls['invoice_total'].setValue(this.invoice_total_figure);

 


  this.invoice_subtotal_figure = (this.invoice_total_figure - this.invoice_tax_figure);
  this.invoice_model.invoice_subtotal = this.invoice_subtotal_figure;
  this.invoiceForm.controls['invoice_subtotal'].setValue(this.invoice_subtotal_figure);



  // updated by
  let update_user = this.sessionUserId;
  this.invoice_model.updated_by = this.sessionUserId;  
  this.invoiceForm.controls['updated_by'].setValue(update_user);


this.invoiceForm.controls['invoice_gst'].setValue(this.invoice_tax_figure);

  this.invoice_model = this.invoiceItem;
  
 // alert('test');
}


// can also run from a child component.
doCalculations__() {
 

  
// + gst
// this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // with qty for tax + GST 
// this.invoice_model.invoice_gst = this.invoice_tax_figure;
 
  // :: Test Stop errors of input
 // this is needed but does throw errows 

 
  // this.invoice_tax_figure = (this.invoice_model.invoice_total / (100 / 10));
// this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates
 this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax), 0); // now calculates
  this.invoice_model.invoice_gst = this.invoice_tax_figure;

  // this.toastr.info('Calculating...');
  this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
  this.invoice_model.invoice_total = this.invoice_total_figure += this.invoice_tax_figure;

  if ( this.invoiceForm.controls['invoice_gst']) {
  this.invoiceForm.controls['invoice_gst'].setValue(this.invoice_tax_figure);
  }
  // this.invoice_subtotal_figure = (this.invoice_model.invoice_total - this.invoice_tax_figure);
  this.invoice_subtotal_figure = (this.invoice_model.invoice_total - this.invoice_tax_figure);
  this.invoice_model.invoice_subtotal = this.invoice_subtotal_figure;
  if ( this.invoiceForm.controls['invoice_subtotal']) {
  this.invoiceForm.controls['invoice_subtotal'].setValue(this.invoice_subtotal_figure);
  }
  // updated by
  let update_user = this.sessionUserId;
  this.invoice_model.updated_by = this.sessionUserId;  
  if ( this.invoiceForm.controls['updated_by']) {
  this.invoiceForm.controls['updated_by'].setValue(update_user);
  }

  if ( this.invoiceForm.controls['invoice_total']) {
    this.invoiceForm.controls['invoice_total'].setValue(this.invoice_total_figure);
    }

  this.invoice_model = this.invoiceItem;
  
 // alert('test');
}


doCalculations_() {

  //  this.invoice_tax_figure = (this.invoice_model.invoice_total / (100 / 10));
  // this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax * b.qty), 0); // now calculates
  
  //  this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates invlusive (current)
  
  this.invoice_tax_figure = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // with qty for tax + GST 
  this.invoice_model.invoice_gst = this.invoice_tax_figure;
    // this.invoice_subtotal_figure = (this.invoice_model.invoice_total - this.invoice_tax_figure); // Plus GST
   // :: Invoice Subtotal does not need tax removed as it is always inclusive in the price
  
  
  
    
    // this.toastr.info('Calculating...'); // moved belwo calculations
    this.invoice_total_figure = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
    // this.invoice_model.invoice_total = this.invoice_total_figure; // includisve
    this.invoice_model.invoice_total = this.invoice_total_figure + this.invoice_tax_figure;
  
  
    //  this.invoice_subtotal_figure = (this.invoice_model.invoice_total); // icusive
  this.invoice_subtotal_figure = (this.invoice_model.invoice_total - this.invoice_tax_figure);
  this.invoice_model.invoice_subtotal = this.invoice_subtotal_figure;
  
    this.invoice_model = this.invoiceItem;


    if ( this.invoiceForm.controls['invoice_gst']) {
      this.invoiceForm.controls['invoice_gst'].setValue(this.invoice_tax_figure);
      }
      // this.invoice_subtotal_figure = (this.invoice_model.invoice_total - this.invoice_tax_figure);
      this.invoice_subtotal_figure = (this.invoice_model.invoice_total);
      this.invoice_model.invoice_subtotal = this.invoice_subtotal_figure;
      if ( this.invoiceForm.controls['invoice_subtotal']) {
      this.invoiceForm.controls['invoice_subtotal'].setValue(this.invoice_subtotal_figure);
      }
      // updated by
      let update_user = this.sessionUserId;
      this.invoice_model.updated_by = this.sessionUserId;  
      if ( this.invoiceForm.controls['updated_by']) {
      this.invoiceForm.controls['updated_by'].setValue(update_user);
      }



   // alert('test');
  }



updateSubjectInvoice(invoice_model){

  invoice_model.invoice_payment_total = 0.00;
  this._demoService.updateSubjectInvoice(invoice_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

// need to update the invoice items as well. or do we update them as we make changes to the invoice itself??? Start Here and work out.
// now inset the items
let  count_of_items = Object.keys(this.invoiceItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.updateSubjectInvoiceItem(invoiceData, this.invoice_id);
// :: TODO need to update subjectBillingItem, as status invoiced.
let invoice_status = "INVOICED";
this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.invoice_id, this.invoice_number, invoiceData);
  } // end for

this.gfunc.insertLog_UpdateInvoice(invoice_model);
  this.toastr.success('Invoice Updated');
  this.closeParentModel.emit();
  this.refreshSujectInvoicePage(this.subject_id);


     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }




 updateSubjectInvoiceAndApprove(invoice_model){
  
  invoice_model.invoice_payment_total = 0.00;

  this._demoService.updateSubjectInvoice(invoice_model).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });

// need to update the invoice items as well. or do we update them as we make changes to the invoice itself??? Start Here and work out.
// now inset the items
let  count_of_items = Object.keys(this.invoiceItemsList).length;
  // need to do a loop of subject_billing items (.length)
  for(let i=0; i < count_of_items; i++) {
   let invoiceData = this.invoiceItemsList[i];
   // :: add the items
   this.updateSubjectInvoiceItem(invoiceData, this.invoice_id);
// :: TODO need to update subjectBillingItem, as status invoiced.
let invoice_status = "INVOICED";
this.updateSubjectBillingItemInvoiceStatus(invoice_status, invoiceData.subject_billing_item_id, this.invoice_id, this.invoice_number, invoiceData);
  } // end for

    // :: updates the invoice status.
  invoice_model.invoice_status_id = 3; // set to approve
  this.updateInvoiceStatus(invoice_model);
  this.gfunc.insertLog_UpdateInvoice(invoice_model);
  this.toastr.success('Invoice Updated + Approved');
  this.closeParentModel.emit();
  this.refreshSujectInvoicePage(this.subject_id);





     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }


 updateSubjectInvoiceItem(model, invoice_id){
  this._demoService.updateSubjectInvoiceItem(model, invoice_id).subscribe(
    data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
      // let res = data[0];
    // this.router.navigate(['../../companies'], { relativeTo: this.route });
     return true;
    },
    error => {
      console.error(error);
   //  this.toastr.error('Adding Failed :: Please try again!');
     // console.log(Observable.throw(error));
      // return Observable.throw(error);
    }
)
 }







toggleShow(index) {
 // this.isShowEdit = ! this.isShowEdit;
// if (this.isShow === index){
// this.isShow = '';
// }else{
//   this.isShow = index; // sets to the array row.d
// }
this.isShow = index; // sets to the array row.d

  }

  toggleHide(index) {
 // this.isShowEdit = ! this.isShowEdit;
// if (this.isShow === index){
// this.isShow = '';
// }else{
//   this.isShow = index; // sets to the array row.d
// }
this.isShow = index; // sets to the array row.d

  }



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



// :: Parent / Child modal test
closeParentModel2() {
 //  alert('parent component function.');
   this.modalRef.hide();
// now refresh the invoice items list from the new items.
    // empty your array first
    this.invoiceItemsList.length = 0;
this.getSubjectBillingItems(this.subject_id);


 // this.closeParentModel.emit(); // ?shuts invoice window
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


// :: Parent / Child modal test
closeParentModel3() {
  //  alert('parent component function.');
    this.modalRef.hide();
 };

RemoveElementFromObjectArray(key: number) {
  let data = this.invoiceItemsList;
      // data.forEach((value, index) => {
      //   if ( value.subject_billing_item_id === key) {
      //     this.row_data.splice(index, 1); }
      // });
      data.forEach((value,index)=>{
        if(value.subject_billing_item_id==key) data.splice(index,1);
    });
// do I need to refesh like adding?
this.doCalculations();

     };


deleteSubjectInvoiceItem(model, invoice_item_id){
    if (confirm('Are you sure you want to delete this item from the invoice. It will still appear in billing items, yet to be invoiced.')) {
      this._demoService.deleteSubjectInvoiceItem(model, invoice_item_id).subscribe(
         data => {
          // update the status of subjectbillingItems
          let invoice_status = 'NOT-INVOICED';
          let invoice_id = 0;
          let invoice_number = 0;
          
          let subject_billing_item_id = model.subject_billing_item_id;
          this.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, model);
          // refresh the list
         ////  this.getSubjectBillingItems(this.invoice_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
          // refresh the bottom widow of sibjectBillingItems from Modal
          this.refreshSujectInvoicePage(this.subject_id);
          /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.
          this.getInvoiceItmes(this.invoice_id);

 this.doCalculations(); //original feb 2023

           return true;
         },
         error => {
           console.error('Error deleting Job File!');
           console.error(error);
           // return Observable.throw(error);
         }
      );
  }
 
}
 
// new Function to do both need to add button
deleteSubjectInvoiceItemAndBillingItem(model, invoice_item_id){
  if (confirm('Are you sure you want to delete this item from the invoice. It will still appear in billing items, yet to be invoiced.')) {
    this._demoService.deleteSubjectInvoiceItem(model, invoice_item_id).subscribe(
       data => {
        // update the status of subjectbillingItems
        let invoice_status = 'NOT-INVOICED';
        let invoice_id = 0;
        let invoice_number = 0;
        
        let subject_billing_item_id = model.subject_billing_item_id;
        // this.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number); // updates and reinstates billing ite,
        this.deleteSubjectBillingItem(subject_billing_item_id) //  // deletes billing item it as well
        // refresh the list
       ////  this.getSubjectBillingItems(this.invoice_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
        // refresh the bottom widow of sibjectBillingItems from Modal
        this.refreshSujectInvoicePage(this.subject_id);
        /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.
        this.getInvoiceItmes(this.invoice_id);
        this.doCalculations(); //original feb 2023
       



         return true;
       },
       error => {
         console.error('Error deleting Job File!');
         console.error(error);
         // return Observable.throw(error);
       }
    );
}

}


deleteSubjectBillingItem(subject_billing_item_id) {
  this._demoService.deleteSubjectBillingItem(subject_billing_item_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
   this.toastr.success('Subject Billing Item Removed.');
   //this.refreshGrid();
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


deleteSubjectCostItem(subject_cost_item_id) {
  this._demoService.deleteSubjectCostItem(subject_cost_item_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
   this.toastr.success('Subject Cost Item Removed.');
  // this.refreshGrid();
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


// Loads from add new billing items modal.
refreshInvoiceItemsBelow() {
  console.log('Reloading Items');
  this.getInvoice(this.invoice_id);
  this.getInvoiceItmes(this.invoice_id);
  this.doCalculations();
}


 refreshSujectInvoicePage(subject_id){
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      //               this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
      this.doCalculations();
                    this.gfunc.globalJobSubjectBillingViewSkipRoute(subject_id);
    
    }




    updateInvoiceCommunicationStatus(invoice_model){
      invoice_model.invoice_id = this.invoice_id;
      this._demoService.updateInvoiceCommunicationStatus(invoice_model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the invoice:
   
        },
        error => {
         // console.error('Error saving Event!');
          this.toastr.error('Error Changing Status of Subject');
          return console.error(error);
        }
       // err => console.error(err),
       //
      )};
    
    updateInvoicePaymentStatus(invoice_model){
      invoice_model.invoice_id = this.invoice_id;
      this._demoService.updateInvoicePaymentStatus(invoice_model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the invoice:
  
        },
        error => {
         // console.error('Error saving Event!');
          this.toastr.error('Error Changing Status of Subject');
          return console.error(error);
        }
       // err => console.error(err),
       //
      )};
    
    
    updateInvoiceStatus(invoice_model){
     invoice_model.invoice_id = this.invoice_id;
     this._demoService.updateInvoiceStatus(invoice_model).subscribe(
       data => { // this.trace_candidate_update = data;
         // refresh the invoice:

       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error Changing Status of Subject');
         return console.error(error);
       }
      // err => console.error(err),
      //
     );
    };



// :: New sytem to Automatically be able to create documents and send via comm templates.


createSubjectInvoicePDF(model, invoice_id) {
  model.doc_id = 20; // client invoice
  model.subject_com_type_id = 3;
  model.allAttachments = []; // so we can push to an empty array.
// See Global Function to See Vars
this.gfunc.createDocument_Invoice(model, invoice_id);
}


createSubjectInvoicePDFAndSend(model, invoice_id) {
  if (confirm('Are you sure? Create Invoice and Send to Client Accounts ')) {
  model.doc_id = 20; // client invoice
  model.subject_com_type_id = 3;
// See Global Function to See Vars
// :: Extra Vars to Establish the send.
// Need to get these variables from the job lookup.... I think.
model.brand_type_id = 2; // client 2 agent 3
model.brand_report_id = 97; // current subject job details
model.brand_invoice_id = 97; // current subject job details
model.brand_work_order_id = null;
model.send_to_invoice = 1; // 1 or 0
model.send_to_report = 0; // 1 or 0
model.send_to_logins = 0; // 1 or 0
model.send_to_report_user = 0; // 1 or 0 // TODO not yet datbased API or coded into the system process
model.additional_message = "Automated Client Invoice Email Via button Press " + this.gfunc.today;
model.allAttachments = [];

this.gfunc.createDocument_InvoiceAndSend(model, invoice_id);
}; // end if
};




deleteInvoiceAndSetBillingItems(invoice_model){
  // if (confirm('Are you sure you want to delete this invoice Myob and Sop. All items will be placed back into specific subject billing items, yet to be invoiced.')) {
  // get all items and loop 
 // :: Remove from myob

 if (invoice_model.myob_id) { // delete from myob
 this._MyobApiInvoiceSyncToolsWidgetComponent.deleteMyobServiceInvoiceModel(invoice_model);
 };

  // remove function and update subject billing items "not-invoiced"
  // end loop
console.log("InvoiceID: " + invoice_model.invoice_id);
  // this.getInvoiceItmes(invoice_model.invoice_id);
  this._demoService.getSubjectInvoiceItems(invoice_model.invoice_id)
  .pipe(
    this.toastr.observe({
       loading: 'Removing and Re-assigning Invoice Items',
       success: '🚀',
       error: '😡'
    })
  )
  .subscribe(
    (data) => {
      this.invoiceItemsList = data;
      let res = data[0];
     // this.invoice_item_model = this.invoiceItemsList;
     console.log( JSON.stringify(this.invoiceItemsList) );
      let newArr = data;
          let  count_of_items = Object.keys(newArr).length;
          for(let i=0;i < count_of_items; i++) {
                  let res = newArr[i];
                  // console.log('Item:' + i + ' ID: ' + res.invoice_item_id);
                  this.deleteSubjectInvoiceItem(res, res.invoice_item_id);
                  // this updates the status NOT invoice of all subject invoice itmes;
          }// end for loop
  // then remove invoice_items and invoice data rows
        this.deleteInvoiceAndItems(invoice_model);
          // update the status of subjectbillingItems // Added was missing Feb 2023
        let invoice_status = 'NOT-INVOICED';
        let invoice_id = invoice_model.invoice_id;
        let invoice_number = invoice_model.invoice_id;
        let subject_billing_item_id = invoice_model.subject_billing_item_id;
        this.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number, invoice_model);

        this.toastr.success('Invoice Removed and Subject Billing Items used now set "Not Invoiced".');
        // Now Reload the page.

        this.gfunc.insertLog_DeleteInvoice(invoice_model);
        this.refreshSujectInvoicePage(this.subject_id);
        // Now hide close the modal invoice
        // this.modalRef.hide();
        this.closeParentModel.emit();
        this.doCalculations(); //original feb 2023
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
    ); // end subscribe.
// } // end confirm
}




deleteInvoiceAndItems(model) {
  // if (confirm('Are you sure you want to delete this invoice and items? ')) {
    this._demoService.deleteInvoice(model.invoice_id).subscribe(
       data => {
       //  this.getTraceCandidateNotes(this.trace_candidate_id);
         return true;
       },
       error => {
         console.error('Error deleting Invoice!');
        return console.log(error);
       }
    );
// }
}



// deleteSubjectInvoiceItem(model, invoice_item_id){
//   // if (confirm('Are you sure you want to delete this item from the invoice. It will still appear in billing items, yet to be invoiced.')) {
//     this._demoService.deleteSubjectInvoiceItem(model, invoice_item_id).subscribe(
//        data => {
//         // update the status of subjectbillingItems
//         let invoice_status = 'NOT-INVOICED';
//         let invoice_id = model.invoice_id;
//         let invoice_number = model.invoice_id;
//         let subject_billing_item_id = model.subject_billing_item_id;
//         this.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number);
//         // refresh the list
//        ////  this.getSubjectBillingItems(this.invoice_id); // seemed to remove all items from the list??? upon delete when they are still in the database...
//         // refresh the bottom widow of sibjectBillingItems from Modal
//         // this.refreshSujectInvoicePage(this.subject_id);
//         /// :: lets do a refresh of the invoice data to refresh the invoice_items_list.
//         // this.getInvoiceItmes(this.invoice_id);
//          return true;
//        },
//        error => {
//          console.error('Error deleting Invoice Items Data!');
//          console.error(error);
//          //return console.log(error);
//        }
//     );
// // }
// }


// updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number){
//   this._demoService.updateSubjectBillingItemInvoiceStatus(invoice_status, subject_billing_item_id, invoice_id, invoice_number).subscribe(
//     data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
//       // let res = data[0];
//     // this.router.navigate(['../../companies'], { relativeTo: this.route });
//      return true;
//     },
//     error => {
//       console.error(error);
//    //  this.toastr.error('Adding Failed :: Please try again!');
//      // console.log(error(error));
//       //return console.log(error);
//     }
// )
//  }



//  refreshSujectInvoicePage(subject_id){
//   // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
//   //               this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
//                 this.gfunc.globalJobSubjectBillingViewSkipRoute(subject_id);

// }


// Position Drop down menu button in top action in open
    // To open popup in particular position.
    public onOpen (args: OpenCloseMenuEventArgs) {
      args.element.parentElement.style.top = this.dropdownbutton.element.getBoundingClientRect().top - args.element.parentElement.offsetHeight +'px';
   }


  }




// Allows formatting of dates etc...
export class DatePipeComponent {
  today: number = Date.now();
  fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
// tslint:disable-next-line:eofline
}